import type { IKompisTranslations } from '@inter-ikea-kompis/types';
import { applicationSettings } from '../settings/application';
import { t } from '../translations';
import store from '../state';
import { selectFlattenedTranslations } from '../state/translations/translationsSelectors';
import type { IStorageTwoTranslations } from '../state/translations/translationsTypes';

const replaceVariables = (translation: string): string =>
  translation
    .replaceAll(
      '{{applicationname}}',
      () => applicationSettings.applicationName
    )
    .replaceAll('{{tip_over_warning_link}}', () =>
      translate(t.TIP_OVER_WARNING_LINK)
    );

export const translate = (
  key: keyof (IKompisTranslations & IStorageTwoTranslations)
): string => {
  const translation = selectFlattenedTranslations(store.getState())?.[key];
  if (!translation) return key;

  return replaceVariables(translation);
};
